<script>
export default {
	name: "HotColdNumbers.vue",
	props: {
		hotNumbers: {
			type: Object,
			required: true
		},
		coldNumbers: {
			type: Object,
			required: true
		}
	},
	methods: {
		pad(n) {
			return String(n).padStart(2, "0")
		}
	}
}
</script>

<template>
	<v-row no-gutters class="text-center">
		<v-col cols="12">
			<div class="main-title">
				NUMBERS
			</div>
		</v-col>
		<v-col cols="6" id="hot-picks">
			<div>Hot Picks</div>
			<v-row justify="center">
				<v-col cols="auto">
					1st
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" class="d-flex justify-center">
					<div v-for="number in hotNumbers.first" :key="number" class="fireball">
						{{ pad(number) }}
					</div>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="auto">
					2nd
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" class="d-flex justify-center">
					<div v-for="number in hotNumbers.second" :key="number" class="fireball">
						{{ pad(number) }}
					</div>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="auto">
					3rd
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" class="d-flex justify-center">
					<div v-for="number in hotNumbers.third" :key="number" class="fireball">
						{{ pad(number) }}
					</div>
				</v-col>
			</v-row>
		</v-col>
		<v-col cols="6" id="cold-picks">
			<div>Cold Picks</div>
			<v-row justify="center">
				<v-col cols="auto">
					1st
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" class="d-flex justify-center">
					<div v-for="number in coldNumbers.first" :key="number" class="iceball">
						{{ pad(number) }}
					</div>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="auto">
					2nd
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" class="d-flex justify-center">
					<div v-for="number in coldNumbers.second" :key="number" class="iceball">
						{{ pad(number) }}
					</div>
				</v-col>
			</v-row>
			<v-row justify="center">
				<v-col cols="auto">
					3rd
				</v-col>
			</v-row>
			<v-row no-gutters>
				<v-col cols="12" class="d-flex justify-center">
					<div v-for="number in coldNumbers.third" :key="number" class="iceball">
						{{ pad(number) }}
					</div>
				</v-col>
			</v-row>
		</v-col>
	</v-row>
</template>

<style scoped lang="scss">
* {
	font-size: 110%;
}

.main-title {
	font-size: 150%;
}

#hot-picks {
	border-right: 1px solid white;
}

.fireball {
	color: black;
	display: flex;
	justify-content: center;
	align-items: flex-end;
	background-image: url("../../assets/img/caribbeanPick/flame.png");
	background-size: contain;
	text-decoration: underline;
	background-repeat: no-repeat;
	height: 80px;
	width: 70px;
}

.iceball {
	margin-top: 10px;
	color: black;
	display: flex;
	justify-content: center;
	align-items: center;
	background-image: url("../../assets/img/caribbeanPick/ice.png");
	filter: grayscale(100%);
	background-size: contain;
	text-decoration: underline;
	background-repeat: no-repeat;
	height: 75px;
	width: 70px;
}

</style>
